import {
  type ID,
  type StickyNote,
  selectStickyNotesByParent,
} from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import cx from 'classnames'
import type React from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import type { AppState } from '@/types'
import { StickyNotesItem } from './components'
import { NOTE_ORIGIN } from './constants'
import css from './StickyNotes.module.scss'

// what the notes hang on: a tab holds the free ones
type Anchor = 'tab' | 'section' | 'page'

type Props = {
  parentId: ID
  // a page measures its notes from its top left corner, a tab from the top
  // middle of the tree and a section from its own top middle
  anchor: Anchor
}

const StickyNotes: React.FC<Props> = ({ parentId, anchor }) => {
  const stickyNotes = useSelector<AppState, StickyNote[]>(
    (state) =>
      selectStickyNotesByParent(parentId)({
        project: state.manager.project,
        relations: state.relations,
      }),
    shallowEqual
  )

  const isReadOnly = useSelector(
    migrationProjectSelector.getProjectLegacyAccessTypeIsReadOnly
  )

  const isDisabled = useSelector<AppState, boolean>(
    ({ artboard }) => artboard.isDisabled
  )

  return (
    <div
      className={cx(css.container, css[anchor], 'sticky-notes')}
      {...{ [NOTE_ORIGIN]: parentId }}
    >
      {stickyNotes.map((data) => (
        <StickyNotesItem
          key={data.id}
          data={data}
          parentId={parentId}
          disabled={isDisabled}
          readOnly={isReadOnly}
        />
      ))}
    </div>
  )
}

export default StickyNotes
